import { useTranslation } from "react-i18next";
import "./style.scss";

const Recommendation = (props) => {
  const { t } = useTranslation("common");

  const constans = {
    readMore: t("recommendations.read_more"),
  };

  return (
    <section className="recommendation-item">
      <a
        className="recommendation-item__anchor"
        href={props.ctaUrl}
        target="__blank"
      >
        {props.header && (
          <header className="recommendation-item__header">
            <h2 className="recommendation-item__header-text paragraph">
              {t(props.header)}
            </h2>
          </header>
        )}

        {props.imageUrl && (
          <div className="recommendation-item__figure">
            <img
              className="recommendation-item__img"
              src={props.imageUrl}
              width="374"
              height="165"
              alt=""
            />
          </div>
        )}

        <div className="recommendation-item__content">
          {props.title && (
            <h3 className="recommendation-item__title headline--quaternary">
              {props.title}
            </h3>
          )}
          {props.description && (
            <p className="recommendation-item__description">
              {props.description}
            </p>
          )}
          {props.priority && (
            <div className="tp-area-helper">Priority: {props.priority}</div>
          )}
          {props.ctaUrl && (
            <span className="recommendation-item__action link">
              {constans.readMore}
            </span>
          )}
        </div>
      </a>
    </section>
  );
};

export default Recommendation;
